import React from "react";
import { LicenseTemplate } from "../../Templates/LicenseTemplate";

export const License = () => {
  return <LicenseTemplate />;
};
